import type { StyledComponentProps } from '@material-ui/core/styles';
import React, { Component } from 'react';

import styles from './styles';

export const MyTableContext = React.createContext({ responsive: true });

interface IProps extends StyledComponentProps {
  responsive?: boolean;
}

class MyTable extends Component<IProps, any> {
  render() {
    const { classes, responsive } = this.props;

    return <table className={classes.root + ' my-table -sales ' + (!responsive ? 'disable-responsive' : '')}>{this.props.children}</table>;
  }
}

export { default as MyTableBody } from './MyTableBody';
export { default as MyTableCol } from './MyTableCol';
export { default as MyTableRow } from './MyTableRow';
export { default as MyTableHeader } from './MyTableHeader';
export { default as MyTablePagination } from './MyTablePagination';
export { default as MyTableWrapper } from './MyTableWrapper';

export default styles(
  React.forwardRef((props: IProps, ref: any) => (
    <MyTableContext.Consumer>{(context) => <MyTable {...props} {...context} ref={ref} />}</MyTableContext.Consumer>
  ))
);
